import { MENTEE_MODULE_STATUSES } from './menteeModuleStatuses';

export const CORE_MENTEE_MODULE_STATUSES = [
  MENTEE_MODULE_STATUSES.completed,
  MENTEE_MODULE_STATUSES.locked,
];
